<script lang="ts">
    import { Col } from "sveltestrap";
    import { Display, Displayheadings, DisplayheadingsMessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>

<Col sm="12">
    <Card cardHeader2props="pb-0" CardBodyprops="typography">
        <div slot="customHeader2">
            <h5>{Displayheadings}</h5>
            <span>{@html DisplayheadingsMessage}</span>
        </div>
        <div slot="contentbody">
            <h1 class="display-1">{Display} 1</h1>
            <h1 class="display-2">{Display} 2</h1>
            <h1 class="display-3">{Display} 3</h1>
            <h1 class="display-4">{Display} 4</h1>
        </div>
    </Card>
</Col>
